
const handleSetDropdownData = (dropdownList, { functions = [] } = {})=> {
  let data = dropdownList || [];

  if (functions.includes('removeNegativeValue')) {
    data = data.filter(item => !['-1', -1].includes(item.value));
  }
  if (functions.includes('removeSelfPay')) {
    data = data.filter(item => !['SELFPAY'].includes(item.value));
  }

  if (functions.includes('setEmptyDefault')) {
    if (Array.isArray(data) && data.length > 0) {
        // Get all keys from the first object
        const keys = Object.keys(data[0]);

        // Create a new object with same keys but empty string values
        const emptyObj = keys.reduce((acc, key) => {
          acc[key] = key === 'value' ? '-1' : '';
        return acc;
        }, {});

        // Prepend the empty object to the array
        data = [emptyObj, ...data];
    }
  }

  return data;
};

export default handleSetDropdownData